<template>
  <div id="AccountSelector">
    <div id="account_selector_left" class="selector_left">
      <TabFilter
        :defaultValue="0"
        :filterList="[
          { label: 'All', value: 0 },
          { label: 'MT4', value: 4 },
          { label: 'MT5', value: 5 }
        ]"
        @filterChange="onFilterChange"
      ></TabFilter>
      <el-select
        v-model="value1"
        size="small"
        multiple
        collapse-tags
        :placeholder="$t('common.field.selectStatus')"
        class="status_select"
        @change="onStatusChange"
      >
        <el-checkbox-group v-model="value1">
          <el-option v-for="item in accountStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            <el-checkbox style="pointer-events: none" :label="item.value">{{ item.label }}</el-checkbox>
          </el-option>
        </el-checkbox-group>
      </el-select>
    </div>
    <div class="selector_right">
      <div class="create_btn" @click="onCreateAccount">
        <span class="el-icon-plus"></span>
        <span>{{ buttonText }}</span>
      </div>
      <div v-if="viewType == 'card'" class="type_switch" @click="onViewTypeChange('list')">
        <img src="@/assets/images/list_view.png" width="36" />
      </div>
      <div v-else class="type_switch" @click="onViewTypeChange('card')">
        <img src="@/assets/images/card_view.png" width="36" />
      </div>
    </div>
  </div>
</template>

<script>
import TabFilter from '@/components/global/TabFilter';
import { mapGetters, mapState } from 'vuex';
import { RegisterRoutePath } from '@/router/registerRoutes';
export default {
  name: 'AccountSelector',
  components: {
    TabFilter
  },
  props: {
    accountType: {
      // 判断是在那个页面使用  live：真实账户， demo： demo账户
      type: String,
      default: 'live'
    },
    accountStatus: {
      type: Array,
      default: []
    },
    platformType: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      viewType: 'card', // 数据展示方式， card：卡片， list: 列表
      liveStatusOptions: [
        { value: 'Active', label: this.$t('home.accStatus.active') },
        { value: 'Rejected', label: this.$t('home.accStatus.rejected') },
        { value: 'Processing', label: this.$t('home.accStatus.processing') },
        { value: 'Pending', label: this.$t('loyalty.status.pending') },
        { value: 'Inactive', label: this.$t('home.accStatus.inactive') }
      ],
      PlatformTypeOptions: [
        { value: 0, label: this.$t('home.accStatus.all') },
        { value: 4, label: 'MT4' },
        { value: 5, label: 'MT5' }
      ],
      DemoStatusOptions: [
        { value: 'Active', label: this.$t('home.accStatus.active') },
        { value: 'Expired', label: this.$t('home.accStatus.expired') }
      ],
      value1: []
    };
  },
  computed: {
    buttonText() {
      return this.accountType === 'live' ? this.$t('openDemoAdditAcc.liveButton') : this.$t('openDemoAdditAcc.button');
    },
    accountStatusOptions() {
      return this.accountType === 'live' ? this.liveStatusOptions : this.DemoStatusOptions;
    },
    ...mapState('common', ['openAccountEnabled', 'countryCode']),
    ...mapGetters('common', ['idPass', 'poaPass'])
  },
  methods: {
    changeLocalVal(str, val) {
      let obj = null;
      obj = JSON.parse(localStorage.getItem(`${this.accountType}`));
      obj[str] = val;
      localStorage.setItem(`${this.accountType}`, JSON.stringify(obj));
    },
    onStatusChange(val) {
      this.changeLocalVal('accountStatus', val);
      this.$emit('update:accountStatus', val);
    },
    onPlatformTypeChange(val) {
      this.changeLocalVal('platformType', val);

      this.$emit('update:platformType', val);
    },
    onViewTypeChange(val) {
      this.viewType = val;
      this.$emit('update:viewType', val);
    },
    onCreateAccount() {
      if (this.accountType === 'demo') {
        this.$router.push({
          name: 'openDemoAccount'
        });
      } else {
        if (
          this.openAccountEnabled &&
          this.idPass &&
          !this.$config.restrictOpenAdditionAccountCountries(this.regulator).includes(parseInt(this.countryCode))
        ) {
          this.$router.push('openLiveAccount');
        } else {
          this.$router.push(RegisterRoutePath.register);
        }
      }
    },
    onFilterChange(value) {
      this.onPlatformTypeChange(value);
    },
    clearFilter() {
      this.value1 = [];
      this.onStatusChange([]);
    }
  },
  watch: {
    accountType: {
      handler(val) {
        let data = {
          accountType: val,
          platformType: this.platformType,
          accountStatus: this.accountStatus
        };
        localStorage.setItem(val, JSON.stringify(data));
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
#AccountSelector {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/ .el-checkbox {
    .el-checkbox__label {
      text-align: left;
    }
  }

  /deep/ .el-select .el-input__inner {
    &::placeholder {
      opacity: 1;
      color: rgba(205, 207, 211, 1) !important;
    }
  }
  .tab_filter_container {
    width: 100%;
  }
  .selector_left {
    display: flex;
    align-items: center;
    .status_select {
      width: 100%;
      margin-left: 30px;
    }
    & /deep/ .el-select {
      color: $primary-dark-blue;
      input {
        &::placeholder {
          color: $primary-dark-blue;
        }
      }
      .el-input__inner {
        background-color: #fff;
      }
    }
  }
  .selector_right {
    display: flex;
    align-items: center;
    .create_btn {
      height: 32px;
      @include rtl-sass-prop(margin-right, margin-left, 15px);
      display: flex;
      align-items: center;
      padding: 10px 20px;
      border: 1px solid $primary-blue;
      border-radius: 30px;
      background-color: transparent;
      cursor: pointer;
      span {
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        color: $primary-blue;
      }
      &:hover {
        color: rgba($primary-dark-blue, 0.1);
        background-color: #eff2f9;
      }
      .el-icon-plus {
        font-weight: 600;
        @include rtl-sass-prop(padding-right, padding-left, 5px);
      }
    }
    .view_switcher {
      display: flex;
      align-items: center;
      // flex: 1 1 70px;
      width: 72px;
      & /deep/ .el-radio-button {
        .el-radio-button__inner {
          // padding: 2px 6px;
          padding: 0;
          width: 36px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: $white;
          border: none;
          .rb_btn {
            display: inline-block;
            width: 24px;
            height: 24px;
          }
          &:hover {
            border-color: rgba(0, 0, 0, 0.2);
          }
        }
        &.is-active {
          .el-radio-button__inner {
            background-color: rgba($primary-blue, 0.2);
            border-color: rgba($primary-blue, 0) !important;
            box-shadow: none;
          }
        }
      }
    }

    .type_switch {
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

/deep/ .el-select-dropdown__item {
  &:hover {
    .el-checkbox__label {
      color: $primary-blue;
    }
  }
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}

@media (max-width: 550px) {
  #AccountSelector {
    display: block;
    .tab_filter_container {
      display: block;
    }
    .selector_left {
      display: block;
      .status_select {
        margin-left: unset;
        margin-top: 15px;
      }
    }
    .selector_right {
      margin-top: 30px;
      .create_btn {
        width: 100%;
        text-align: center;
        justify-content: center;
      }
    }
  }

  /deep/ .tab_filter_item {
    width: calc(100% / 3);
    text-align: center;
  }
}
</style>
